export const formatAmount = (value) => {
    if (value == null || isNaN(value)) return '';
    return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        maximumFractionDigits: 0,
    }).format(value);
};
